import { fblthpTotallyLostArtCrop } from "@/lib/backupCard";
import { cn } from "@/lib/utils";
import { CheckIcon } from "lucide-react";
import Image from "next/image";

interface Props {
	alt: string;
	src?: string;
	selected?: boolean;
	className?: string;
	containerClassName?: string;
}

export const CardImageInCommandItem: React.FC<Props> = ({
	alt,
	src,
	selected,
	className,
	containerClassName,
}) => {
	return (
		<div className={cn("relative", containerClassName)}>
			<Image
				alt={alt}
				src={src || fblthpTotallyLostArtCrop}
				height={31}
				width={42}
				className={cn("rounded h-[31px] w-[42px] object-cover", className)}
			/>
			{selected && (
				<div className="absolute inset-0 bg-black bg-opacity-50 rounded flex items-center justify-center">
					<CheckIcon className="text-white h-8 w-8" />
				</div>
			)}
		</div>
	);
};
